"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Editor = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _AttachmentList = _interopRequireDefault(require("./Attachments/AttachmentList"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("@insided/shared/uikit/Editor/Attachments/utils");

var _AddTopicCardModal = _interopRequireDefault(require("./AddTopicCardModal"));

var _ErrorList = _interopRequireDefault(require("./ErrorList"));

var _observeMentions = require("./observeMentions");

var _utils2 = require("./utils");

var _Poll = _interopRequireDefault(require("./Poll"));

var _contentConverter = require("./contentConverter");

var _AttachmentUploader = _interopRequireWildcard(require("./Attachments/AttachmentUploader"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _Button2 = _interopRequireDefault(require("@insided/deprecated-control/ui-components/Button"));

var _GlobalClick = _interopRequireDefault(require("@insided/shared/uikit/GlobalClick"));

var _phrase = _interopRequireWildcard(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _attachments2 = require("@insided/deprecated-libs/ckeditor/attachments");

var _UserContext = require("@insided/shared/services/UserContext");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EmojiSelector;
var CKEditor; // This is an important component that is used in many places in the application. Fixing all eSLint rules needs to be done as a separate ticket.

/* eslint-disable */

var Editor = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Editor, _Component);

  var _super = _createSuper(Editor);

  function Editor(props) {
    var _props$attachments, _props$data, _props$data2, _props$data3;

    var _this;

    (0, _classCallCheck2.default)(this, Editor);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "initialData", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "initialEditorContent", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "attachmentUploader", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "editorContent", void 0);

    require('../../../utils/replaceWithPolyfill');

    require('../../../utils/removePolyfill');

    require('../../../utils/childNodeBeforePolyfill');

    require('../../../utils/parentNodeAppendPolyfill');

    if (props.CKEditor) CKEditor = props.CKEditor;
    _this.state = {
      attachments: (_props$attachments = props.attachments) !== null && _props$attachments !== void 0 && _props$attachments.length ? (0, _utils.prepareAttachmentsForState)(props.attachments) : [],
      attachmentErrors: [],
      editorErrors: [],
      attachmentToProcess: 0,
      imageToProcess: 0,
      editor: null,
      enablePoll: props.poll != null,
      poll: props.poll != null ? props.poll : {
        question: '',
        options: []
      },
      showTopicCardModal: false
    };
    _this.initialData = (_props$data = props.data) !== null && _props$data !== void 0 ? _props$data : '';
    _this.editorContent = (_props$data2 = props.data) !== null && _props$data2 !== void 0 ? _props$data2 : '';
    _this.initialEditorContent = (0, _contentConverter.toEditorFormat)((_props$data3 = props.data) !== null && _props$data3 !== void 0 ? _props$data3 : '');
    _this.editorContent = _this.initialEditorContent;
    _this.submitContent = _this.submitContent.bind((0, _assertThisInitialized2.default)(_this));
    _this.setNewEditorInstance = _this.setNewEditorInstance.bind((0, _assertThisInitialized2.default)(_this));
    _this.togglePoll = _this.togglePoll.bind((0, _assertThisInitialized2.default)(_this));
    _this.editPoll = _this.editPoll.bind((0, _assertThisInitialized2.default)(_this));
    _this.getInitialEditorContent = _this.getInitialEditorContent.bind((0, _assertThisInitialized2.default)(_this));
    _this.showNotification = _this.showNotification.bind((0, _assertThisInitialized2.default)(_this));
    _this.onEmojiSelect = _this.onEmojiSelect.bind((0, _assertThisInitialized2.default)(_this));
    _this.onTopicCardClicked = _this.onTopicCardClicked.bind((0, _assertThisInitialized2.default)(_this));
    _this.onAdd = _this.onAdd.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClose = _this.onClose.bind((0, _assertThisInitialized2.default)(_this));
    _this.onDismissError = _this.onDismissError.bind((0, _assertThisInitialized2.default)(_this));
    _this.getCancelButton = _this.getCancelButton.bind((0, _assertThisInitialized2.default)(_this));
    _this.getSubmitButton = _this.getSubmitButton.bind((0, _assertThisInitialized2.default)(_this));
    _this.onSelectEmoji = _this.onSelectEmoji.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeContent = _this.onChangeContent.bind((0, _assertThisInitialized2.default)(_this));
    _this.attachmentUploader = new _AttachmentUploader.default();
    return _this;
  }

  (0, _createClass2.default)(Editor, [{
    key: "getEditorContent",
    value: function getEditorContent() {
      if (this.editorContent === undefined) {
        return this.initialData;
      }

      return this.editorContent;
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var _attachments;

      var attachments = _ref.attachments;
      attachments = (_attachments = attachments) !== null && _attachments !== void 0 ? _attachments : [];
      if (this.state.attachments.length) return;
      this.setState({
        attachments: (0, _utils.prepareAttachmentsForState)(attachments)
      });
    }
  }, {
    key: "preloadPhrases",
    value: function preloadPhrases(cb) {
      var noop = function noop() {};

      _utils2.requiredPhrases.forEach(function (_ref2, idx) {
        var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
            m = _ref3[0],
            p = _ref3[1];

        if (idx === _utils2.requiredPhrases.length - 1) return (0, _phrase.fetchPhrase)(m, p, noop, cb);
        (0, _phrase.fetchPhrase)(m, p, noop);
      });
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this2 = this;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.preloadPhrases(function () {
                  if (CKEditor) return _this2.setState({
                    loaded: true
                  });

                  require.ensure(['../../../libs/ckeditor/ckeditor.js', '../../../libs/emoji/selector'], function (require) {
                    CKEditor = require('../../../libs/ckeditor/ckeditor.js').default;
                    EmojiSelector = require('../../../libs/emoji/selector').default;

                    _this2.setState({
                      loaded: true
                    });
                  }, 'ckeditor');
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "attachmentError",
    value: function attachmentError(filename, errorPhrase, allowedFilesSize) {
      this.setState(function (_ref4) {
        var attachmentToProcess = _ref4.attachmentToProcess,
            attachmentErrors = _ref4.attachmentErrors;
        return {
          attachmentToProcess: attachmentToProcess - 1,
          attachmentErrors: attachmentErrors.concat({
            filename: filename,
            errorPhrase: errorPhrase,
            allowedFilesSize: allowedFilesSize !== null && allowedFilesSize !== void 0 ? allowedFilesSize : _utils.allowedFilesError.allowed_files_size
          })
        };
      });
    }
  }, {
    key: "uploadFile",
    value: function () {
      var _uploadFile = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(file) {
        var _this3 = this;

        var uploadData, attachmentId;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                attachmentId = this.attachmentUploader.getUniqueAttachmentId(); // Add empty attachment to show the loader

                this.updateAttachments([].concat((0, _toConsumableArray2.default)(this.state.attachments), [{
                  attachmentId: attachmentId,
                  source: '',
                  source_thumb: '',
                  type: this.attachmentUploader.getType(file),
                  file_original_name: file.name,
                  file_size: file.size,
                  file_uuid: '',
                  url: '',
                  filename: file.name
                }]));
                _context2.prev = 2;
                _context2.next = 5;
                return this.attachmentUploader.uploadFile(attachmentId, file);

              case 5:
                uploadData = _context2.sent;
                _context2.next = 13;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](2);

                if (_context2.t0 instanceof _AttachmentUploader.FileSizeError) {
                  this.attachmentError(file.name, 'js.uploader.error_file_size', _context2.t0.allowedFileSize);
                } else if (_context2.t0 instanceof _AttachmentUploader.TotalFileSizeError) {
                  this.attachmentError(file.name, 'js.attachments.error_total_file_size_per_post');
                } else if (_context2.t0 instanceof _AttachmentUploader.FileTypeError) {
                  this.attachmentError(file.name, 'js.uploader.error_file_type');
                } else {
                  this.attachmentError(file.name, 'js.uploader.error_on_upload');
                }

                this.updateAttachments(this.state.attachments.filter(function (attachment) {
                  return 'attachmentId' in attachment ? attachment.attachmentId !== attachmentId : true;
                }));
                return _context2.abrupt("return");

              case 13:
                this.setState({
                  attachmentToProcess: this.state.attachmentToProcess - 1
                }, function () {
                  _this3.updateAttachments(_this3.state.attachments.map(function (attachment) {
                    // @ts-expect-error
                    if ('id' in attachment || 'content_id' in attachment || (attachment === null || attachment === void 0 ? void 0 : attachment.attachmentId) !== attachmentId) return attachment;
                    var urlOrSource = 'source' in uploadData ? uploadData.source : uploadData.download_url;
                    return Object.assign(attachment, {
                      url: urlOrSource,
                      source: urlOrSource,
                      source_thumb: 'source_thumb' in uploadData ? uploadData.source_thumb : uploadData.download_url,
                      file_uuid: 'uuid' in uploadData ? uploadData.uuid : ''
                    });
                  }));
                });

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 8]]);
      }));

      function uploadFile(_x) {
        return _uploadFile.apply(this, arguments);
      }

      return uploadFile;
    }()
  }, {
    key: "uploadAttachments",
    value: function () {
      var _uploadAttachments = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(files) {
        var i;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.setState({
                  attachmentToProcess: files.length
                });
                i = 0;

              case 2:
                if (!(i < files.length)) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 5;
                return this.uploadFile(files[i]);

              case 5:
                i++;
                _context3.next = 2;
                break;

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function uploadAttachments(_x2) {
        return _uploadAttachments.apply(this, arguments);
      }

      return uploadAttachments;
    }()
  }, {
    key: "updateAttachments",
    value: function updateAttachments(attachments) {
      var _this$state = this.state,
          imageToProcess = _this$state.imageToProcess,
          attachmentToProcess = _this$state.attachmentToProcess;
      this.setState({
        attachments: attachments
      });
      if (!this.props.onChange) return;
      this.props.onChange(this.getEditorContent(), (0, _utils.prepareAttachments)(attachments), !!imageToProcess || !!attachmentToProcess);
    }
  }, {
    key: "deleteAttachment",
    value: function deleteAttachment(index) {
      this.updateAttachments(this.state.attachments.filter(function (_, idx) {
        return idx !== index;
      }));
    }
  }, {
    key: "submitContent",
    value: function submitContent(content, attachments, onSubmit) {
      if (this.props.isGuest) {
        var event = new window.CustomEvent('GuestUserAction');
        window.dispatchEvent(event);
        return;
      }

      if (!onSubmit) {
        return;
      }

      onSubmit(content, (0, _utils.prepareAttachments)(attachments), !!this.state.imageToProcess || !!this.state.attachmentToProcess);
    }
  }, {
    key: "setNewEditorInstance",
    value: function setNewEditorInstance(instance) {
      var _this4 = this;

      this.setState({
        editor: instance
      }, function () {
        var _this4$state$editor, _this4$state$editor2, _this4$props$onInstan, _this4$props;

        (_this4$state$editor = _this4.state.editor) === null || _this4$state$editor === void 0 ? void 0 : _this4$state$editor.on('filesToProcessCountChange', function (evt) {
          _this4.setState({
            imageToProcess: evt.data.count
          });
        });
        (_this4$state$editor2 = _this4.state.editor) === null || _this4$state$editor2 === void 0 ? void 0 : _this4$state$editor2.on('pollButtonClicked', function () {
          _this4.togglePoll();
        });

        if (!_this4.props.disableMentions) {
          (0, _observeMentions.observeMentions)();
        }

        (_this4$props$onInstan = (_this4$props = _this4.props).onInstanceReady) === null || _this4$props$onInstan === void 0 ? void 0 : _this4$props$onInstan.call(_this4$props);
      });
    }
  }, {
    key: "togglePoll",
    value: function togglePoll() {
      var _this$props = this.props,
          isControl = _this$props.isControl,
          onPollUpdate = _this$props.onPollUpdate;
      this.setState(function (_ref5) {
        var enablePoll = _ref5.enablePoll;
        return {
          enablePoll: !enablePoll,
          poll: {
            question: '',
            options: []
          }
        };
      });
      if (isControl) onPollUpdate === null || onPollUpdate === void 0 ? void 0 : onPollUpdate(null);
    }
  }, {
    key: "editPoll",
    value: function editPoll(newValue) {
      var _this5 = this;

      var newPoll = _objectSpread(_objectSpread({}, this.state.poll), newValue);

      this.setState({
        poll: newPoll
      }, function () {
        var _this5$props$onPollUp, _this5$props;

        return (_this5$props$onPollUp = (_this5$props = _this5.props).onPollUpdate) === null || _this5$props$onPollUp === void 0 ? void 0 : _this5$props$onPollUp.call(_this5$props, newPoll);
      });
    }
  }, {
    key: "getInitialEditorContent",
    value: function getInitialEditorContent() {
      var errors = this.props.errors;
      var hasErrors = Array.isArray(errors) && errors.length > 0;
      return hasErrors ? null : this.initialEditorContent;
    }
  }, {
    key: "showNotification",
    value: function showNotification(category, phrase) {
      this.setState(function (_ref6) {
        var editorErrors = _ref6.editorErrors;
        return {
          editorErrors: editorErrors.concat({
            category: category,
            phrase: phrase
          })
        };
      });
    }
  }, {
    key: "onEmojiSelect",
    value: function onEmojiSelect(evt) {
      var emojiCallback = this.state.emojiCallback;

      if (emojiCallback) {
        return this.setState({
          emojiCallback: null
        });
      }

      this.setState({
        emojiCallback: evt.data.onSelect
      });
    }
  }, {
    key: "onTopicCardClicked",
    value: function onTopicCardClicked(evt) {
      var data = evt.data;
      this.setState({
        showTopicCardModal: true,
        onAddTopic: data.onAdd
      });
    }
  }, {
    key: "onAdd",
    value: function onAdd(topic) {
      var _this6 = this;

      this.setState({
        showTopicCardModal: false
      }, function () {
        var _this6$state$onAddTop, _this6$state;

        return (_this6$state$onAddTop = (_this6$state = _this6.state).onAddTopic) === null || _this6$state$onAddTop === void 0 ? void 0 : _this6$state$onAddTop.call(_this6$state, topic);
      });
    }
  }, {
    key: "onClose",
    value: function onClose() {
      this.setState({
        showTopicCardModal: false
      });
    }
  }, {
    key: "onDismissError",
    value: function onDismissError() {
      this.setState({
        attachmentErrors: []
      });
    }
  }, {
    key: "onChangeContent",
    value: function onChangeContent(content) {
      var _this$props2 = this.props,
          input = _this$props2.input,
          onChange = _this$props2.onChange;
      content = content.replace(/<oembed(.*)\/>/g, '<oembed$1></oembed>');
      content = (0, _contentConverter.fromEditorFormat)(content);
      content = content.replace(/\n/g, '');
      var dom = document.createElement('div');
      dom.innerHTML = _attachments2.hiddenUploadElementHtml;
      content = content.replace(dom.innerHTML, '');
      if (this.editorContent && (0, _utils2.compareHtml)(content, this.editorContent)) return;

      if (this.editorContent !== undefined && typeof onChange === 'function') {
        onChange(content, (0, _utils.prepareAttachments)(this.state.attachments), !!this.state.imageToProcess || !!this.state.attachmentToProcess);
      }

      this.editorContent = content;
      if (!input) return;
      var inputElement = document.querySelector(input);
      if (!inputElement) return;
      inputElement.value = content;
    }
  }, {
    key: "onSelectEmoji",
    value: function onSelectEmoji(unicode, shortname) {
      var emojiCallback = this.state.emojiCallback;
      this.setState({
        emojiCallback: null
      });

      if (typeof emojiCallback === 'function') {
        emojiCallback(unicode, shortname);
      }
    }
  }, {
    key: "getCancelButton",
    value: function getCancelButton() {
      var _this$props3 = this.props,
          isControl = _this$props3.isControl,
          onCancel = _this$props3.onCancel,
          cancelPhrase = _this$props3.cancelPhrase;
      return isControl ? (0, _preact.h)(_Button.default, {
        variant: "secondary",
        onClick: onCancel ? function () {
          return onCancel();
        } : undefined,
        title: (0, _preact.h)(_phrase.default, {
          p: cancelPhrase !== null && cancelPhrase !== void 0 ? cancelPhrase : 'Cancel'
        })
      }) : (0, _preact.h)(_Button2.default, {
        secondary: true,
        link: true,
        onClick: onCancel ? function () {
          return onCancel();
        } : undefined
      }, (0, _preact.h)(_phrase.default, {
        p: cancelPhrase !== null && cancelPhrase !== void 0 ? cancelPhrase : 'Cancel'
      }));
    }
  }, {
    key: "getSubmitButton",
    value: function getSubmitButton() {
      var _this7 = this;

      var _this$props4 = this.props,
          isControl = _this$props4.isControl,
          btnText = _this$props4.btnText,
          btnPhrase = _this$props4.btnPhrase,
          isLoading = _this$props4.isLoading,
          onCancel = _this$props4.onCancel,
          onSubmit = _this$props4.onSubmit,
          sendButtonText = _this$props4.sendButtonText;
      var submitButtonText = btnText !== null && btnText !== void 0 ? btnText : (0, _preact.h)(_phrase.default, {
        p: btnPhrase !== null && btnPhrase !== void 0 ? btnPhrase : 'Send'
      });
      return isControl ? (0, _preact.h)(_Button.default, {
        "data-qa": "reply-submit-button",
        disabled: isLoading,
        variant: onCancel ? 'success' : 'primary',
        onClick: function onClick() {
          return _this7.submitContent(_this7.getEditorContent(), _this7.state.attachments, onSubmit);
        },
        isLoading: isLoading,
        title: sendButtonText !== null && sendButtonText !== void 0 ? sendButtonText : onCancel ? 'Save changes' : submitButtonText
      }) : (0, _preact.h)(_Button2.default, {
        "data-qa": "reply-submit-button",
        primary: true,
        loading: isLoading,
        disabled: isLoading,
        onClick: function onClick() {
          return _this7.submitContent(_this7.getEditorContent(), _this7.state.attachments, onSubmit);
        }
      }, submitButtonText);
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      var _this$props5 = this.props,
          onCancel = _this$props5.onCancel,
          onSubmit = _this$props5.onSubmit,
          isControl = _this$props5.isControl,
          autoFocus = _this$props5.autoFocus,
          errors = _this$props5.errors,
          cssLink = _this$props5.cssLink,
          disableFileAttachments = _this$props5.disableFileAttachments,
          disableMentions = _this$props5.disableMentions,
          placeholder = _this$props5.placeholder,
          canHavePoll = _this$props5.canHavePoll,
          classes = _this$props5.classes,
          error = _this$props5.error,
          profile = _this$props5.profile,
          permissions = _this$props5.permissions,
          sendButtonText = _this$props5.sendButtonText,
          showEmbedMedia = _this$props5.showEmbedMedia,
          _this$props5$callback = _this$props5.callback,
          callback = _this$props5$callback === void 0 ? function () {} : _this$props5$callback,
          disallowedContent = _this$props5.disallowedContent;

      var _ref7 = permissions || {},
          userPermissions = _ref7.permissions;

      var canShowEmbedMedia = showEmbedMedia !== undefined ? showEmbedMedia : isControl ? true : userPermissions.includes('forum.post.embedmedia.upload');
      var _this$state2 = this.state,
          editorErrors = _this$state2.editorErrors,
          emojiCallback = _this$state2.emojiCallback,
          showTopicCardModal = _this$state2.showTopicCardModal,
          enablePoll = _this$state2.enablePoll,
          attachments = _this$state2.attachments,
          attachmentErrors = _this$state2.attachmentErrors;
      var additionalClasses = classes !== null && classes !== void 0 ? classes : [];
      return (0, _preact.h)("div", {
        className: "html-editor__wrapper"
      }, errors && (0, _preact.h)(_ErrorList.default, {
        errors: errors
      }), (0, _preact.h)("div", {
        className: _classnames.default.apply(void 0, [{
          'validation-error': error
        }, 'html-editor'].concat((0, _toConsumableArray2.default)(additionalClasses), [isControl && 'html-editor--control']))
      }, (0, _preact.h)(_ErrorList.default, {
        errors: editorErrors.map(function (_ref8) {
          var category = _ref8.category,
              phrase = _ref8.phrase;
          return {
            errorMessage: (0, _preact.h)(_phrase.default, {
              m: category,
              p: phrase,
              count: {
                allowed_files_size: '5MB',
                allowed_files_type: 'jpg, png, gif, bmp, webp'
              }
            })
          };
        })
      }), CKEditor && // @ts-expect-error
      (0, _preact.h)(CKEditor, {
        disableFileAttachments: disableFileAttachments,
        showEmbedMedia: canShowEmbedMedia,
        disableMentions: disableMentions,
        canHavePoll: canHavePoll,
        isControl: isControl,
        autoFocus: autoFocus,
        onInstanceReady: function onInstanceReady(instance) {
          return _this8.setNewEditorInstance(instance);
        },
        callback: callback,
        data: this.getInitialEditorContent(),
        onFileAttachment: /*#__PURE__*/function () {
          var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(evt) {
            return _regenerator.default.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return _this8.uploadAttachments(evt.data.files);

                  case 2:
                    return _context4.abrupt("return", _context4.sent);

                  case 3:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));

          return function (_x3) {
            return _ref9.apply(this, arguments);
          };
        }(),
        isGuest: this.props.isGuest,
        placeholder: placeholder,
        cssLink: cssLink,
        profile: profile,
        showNotification: this.showNotification,
        onEmojiSelect: this.onEmojiSelect,
        onTopicCardClicked: this.onTopicCardClicked,
        onFocus: function onFocus() {},
        onChange: this.onChangeContent,
        disallowedContent: disallowedContent
      }), emojiCallback && EmojiSelector && (0, _preact.h)("div", {
        className: "emoji-selector-positioner-background"
      }), emojiCallback && EmojiSelector && (0, _preact.h)(_GlobalClick.default, {
        onGlobalClick: function onGlobalClick() {
          _this8.setState({
            emojiCallback: null
          });
        },
        className: "emoji-selector-positioner"
      }, (0, _preact.h)(EmojiSelector, {
        onSelect: this.onSelectEmoji
      })), showTopicCardModal && (0, _preact.h)(_AddTopicCardModal.default, {
        isOpen: showTopicCardModal,
        onAdd: this.onAdd,
        onClose: this.onClose
      })), enablePoll && (0, _preact.h)(_Poll.default, (0, _extends2.default)({}, this.state.poll, {
        onDelete: this.togglePoll,
        onChange: function onChange(newValue) {
          return _this8.editPoll(newValue);
        }
      })), (0, _preact.h)(_AttachmentList.default, {
        attachments: attachments,
        errors: attachmentErrors,
        onDelete: function onDelete(idx) {
          return _this8.deleteAttachment(idx);
        },
        onDismissError: this.onDismissError
      }), (0, _preact.h)("div", {
        className: "html-editor__buttons"
      }, onSubmit && this.getSubmitButton(), onCancel && this.getCancelButton()));
    }
  }]);
  return Editor;
}(_preact.Component);

exports.Editor = Editor;

var _default = (0, _UserContext.withUserContext)(Editor);
/* eslint-enable */


exports.default = _default;